import ForbiddenPage from "@/components/ui/ForbiddenPage/ForbiddenPage";
import React from "react";

import { useGates } from "..";

import useShouldWait from "./useShouldWait";

export default function CanAnyGuard({ gates, children, ...rest }) {
  const { canAny } = useGates(rest);
  return useShouldWait() ? <></> : canAny(gates) ? children : <ForbiddenPage />;
}
